export default __webpack_public_path__ + "static/media/alexa6.b46d0572.webp";